/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Mark_Ready_Confirm_ButtonInputs */

const fr_week_session_mark_ready_confirm_button = /** @type {(inputs: Week_Session_Mark_Ready_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer prête`)
};

/**

* @param {Week_Session_Mark_Ready_Confirm_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_mark_ready_confirm_button = /** @type {((inputs?: Week_Session_Mark_Ready_Confirm_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Mark_Ready_Confirm_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_mark_ready_confirm_button(inputs)
});